import { type PropertyFactProps } from './PropertyFact';

/**
 * Prepares the columns for displaying property details in two columns.
 */
export const prepareDetailsColumns = (propertyDetails: PropertyFactProps[]) => {
  const filteredDetails = propertyDetails.filter((fact) => fact.content);
  const middleIndex = Math.ceil(filteredDetails.length / 2);
  const leftColumn = filteredDetails.slice(0, middleIndex);
  const rightColumn = filteredDetails.slice(middleIndex);

  return [leftColumn, rightColumn] as const;
};
